<template>
    <ul class="bar-thickness">
        <li class="s" :class="{active: value === 1}" value="1" @click="change(1)">S</li>
        <li class="m" :class="{active: value === 2}" value="2" @click="change(2)">M</li>
        <li class="l" :class="{active: value === 3}" value="3" @click="change(3)">L</li>
    </ul>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps(['initialValue', 'modelValue']);
const emit = defineEmits(['update:modelValue']);
const value = ref(props.initialValue);

watch(() => props.initialValue, (newValue) => {
    value.value = newValue;
});

function change(newValue) {
    value.value = newValue;
    emit('update:modelValue', value.value);
}
</script>

<style lang="scss">
.bar-thickness {
    @apply list-none inline-flex m-0 p-0 pl-2;

    li {
        @apply cursor-pointer m-0 mx-1 p-0 px-1 border-b border-black;
        @apply text-center font-bold;

        &.active {
            @apply border-yellow-500 text-yellow-500;
        }
    }

    .s {
        @apply border-b;
    }
    .m {
        @apply border-b-2;
    }
    .l {
        @apply border-b-3;
    }
}
</style>
